import { UserRef } from '@rygen/rygen-ui/model';

import {
  BatchCancelOrderCommand,
  BatchCloneOrderCommand,
  HttpHeader,
  Order,
  OrderInviteCarriersToSpotMarketBatchCommand,
  SpotMarket,
  UserAssignmentType,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'batch/orders';

export class OrderBatchController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async addTags(ids: number[], tags: string[]): Promise<number[]> {
    const response = await this.http.put<number[]>('tags', { ids, tags });
    return response.data;
  }

  async assignUsers(
    orderIds: number[],
    assignedUsers: UserRef[],
    type: UserAssignmentType,
  ): Promise<number[]> {
    const response = await this.http.post(`users`, {
      orderIds,
      assignedUsers,
      type,
    });
    return response.data;
  }

  async cancel(
    orderIds: Array<number>,
    batchCancelOrderCommand: BatchCancelOrderCommand,
  ): Promise<number[]> {
    const response = await this.http.post<number[]>(
      `${orderIds}/cancel`,
      batchCancelOrderCommand,
    );
    return response.data;
  }

  async clone(
    batchCloneOrderCommand: BatchCloneOrderCommand,
  ): Promise<number[]> {
    const response = await this.http.post<number[]>(
      'clone',
      batchCloneOrderCommand,
    );
    return response.data;
  }

  async create(order: Order, numOrders: number): Promise<number[]> {
    if (order.id) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<number[]>(
      '',
      {
        order,
        numOrders,
      },
      {
        headers: {
          [HttpHeader.SOURCE]: 'Order Entry',
        },
      },
    );
    return response.data;
  }

  async inviteCarriersToSpotMarket(
    command: OrderInviteCarriersToSpotMarketBatchCommand,
  ): Promise<SpotMarket[]> {
    const response = await this.http.post<SpotMarket[]>(
      `spot-market/invite`,
      command,
    );
    return response.data.map((s) => new SpotMarket(s));
  }
}
